export default "__VITE_ASSET__DC357$eK__"